export const APP_NAME = 'Liquid Fuels Gateway' as const;
export const SUPPORT_EMAIL = 'petroleum.statistics@dcceew.gov.au' as const;
export const PRIVACY_POLICY_LINK = 'https://www.dcceew.gov.au/sites/default/files/documents/privacy-policy.pdf' as const;
export const TERMS_AND_CONDITIONS_LINK = '/terms-and-conditions' as const;
export const TERMS_AND_CONDITIONS_CONTENT_KEY = 'UserTermsConditions' as const;
export const SESSION_SYNC_KEY = 'lfgResetTimer' as const;